module.exports = __webpack_public_path__ + "img/findreport.a7f8d159.png";